module.exports = __webpack_public_path__ + "img/经济管理.93bd9a91.png";